import { render, staticRenderFns } from "./ApplyForTop.vue?vue&type=template&id=24b593c2&scoped=true&"
import script from "./ApplyForTop.vue?vue&type=script&lang=js&"
export * from "./ApplyForTop.vue?vue&type=script&lang=js&"
import style0 from "./ApplyForTop.vue?vue&type=style&index=0&id=24b593c2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b593c2",
  null
  
)

export default component.exports